export const contactsData = {
    email: 'ekihi199@gmail.com',
    phone: '+62 82364629599',
    address: 'Vittoria residence, west jakarta, cengkareng - INDONESIA',

    sheetAPI: ''
}